angular.module('app.financeiro').factory('situacaoPagamentoAutomaticoFactory', ['$http', '$q', 'errorService', function ($http, $q, errorService) {

    var _apiName = 'PropostaPagamentoAutomatico';

    var _list = function (search, options, dataInicio, dataTermino, situacao, listaPropostas) {

        var dto = options.data;
        dto.search = search;
        dto.parms = [];
        dto.parms.push({ "name": "DataInicio", "value": dataInicio });
        dto.parms.push({ "name": "DataTermino", "value": dataTermino });
        dto.parms.push({ "name": "Situacao", "value": situacao });
        if (listaPropostas && listaPropostas.length > 0) {
            dto.parms.push({ "name": "ListaPropostas", "value": JSON.stringify(listaPropostas) });
        }

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/List', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _reprocessar = function (dataItem) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/Reprocessar', dataItem);
    }

    var _listElegiveisLote = function (search, dataInicio, dataTermino, situacao, listaPropostas) {
        var dto = { search: search, export: true, parms: [] };
        dto.parms.push({ "name": "DataInicio", "value": dataInicio });
        dto.parms.push({ "name": "DataTermino", "value": dataTermino });
        dto.parms.push({ "name": "Situacao", "value": situacao });
        if (listaPropostas && listaPropostas.length > 0) {
            dto.parms.push({ "name": "ListaPropostas", "value": JSON.stringify(listaPropostas) });
        }

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/List', dto);
    };

    var _reprocessarLote = function (propostas) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ReprocessarLote', propostas);
    };

    var factory = {};

    factory.list = _list;
    factory.reprocessar = _reprocessar;
    factory.listElegiveisLote = _listElegiveisLote;
    factory.reprocessarLote = _reprocessarLote;

    return factory;

}]);
